import PartnerLogos from './partner-logos'

export default PartnerLogos
